import { ToasterComponent } from './../../../toasterComponent/toasterComponent';
import { BiUrls } from './../../biUrls';
import { MDMService } from './../services/mdmService.service';
import { Component, Input, ViewContainerRef, EventEmitter, Output } from "@angular/core";
import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateConverter } from '../../common/service/ngbDateConverter.utils';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbTimeConverter } from '../../common/service/ngbTimeConverter.utils';

import * as _ from 'underscore';


@Component({
    selector: 'measureEditor',
    templateUrl: 'measureEdit.component.html'
})

export class MeasureEditComponent {
    @Input() parent: any;
    @Input() measureData: any;
    @Input() isEdit: boolean = false;
    @Input() inEdit: boolean;
    @Input() isStarSchema: boolean = false;
    @Output() triggerSave = new EventEmitter();
    @Output() triggerBack = new EventEmitter();
    public saveButtonDisable: boolean = false;
    public trgMeasures: any = [];
    public trgDimension: any = [];
    public trgValues: any = [];
    public copyDim: any = [];
    public corTrgList: any = [];
    public trgType: any = 'Static';
    public indicators: any = [];
    public measureTargets: any = [];
    public target: any;
    public datePicker: boolean = false;
    public loader: boolean = false;
    public dataVersionDate: NgbDateStruct;
    public dataVersionType: string = '';
    public uomList: any = [];
    public dimensionExpression: any;
    public dimLevelMap = new Map();
    public dimLevelIdMap = new Map();
    public mentionConfig: any = {};
    public filterDim: any;
    public filterType: any = null;
    public filterValue: any = [];
    public dimensionFilterList = [];
    public levelMap = new Map();
    public dimFilterSettings = {};
    public spinner = true;
    public selectedDimLvlId: any = [];
    public timeDimensionMap = new Map();
    public timeDimensionKey: any = [];

    // public mentionConfig: any = { triggerChar: '`', labelKey: 'name', mentionSelect: this.getDimensionData.bind(this)}

    public dataVersionTime: NgbTimeStruct = { hour: null, minute: null, second: null };
    public startDataVersion: NgbDateStruct = { day: null, month: null, year: null };
    public startDataVersionTime: NgbTimeStruct = { hour: null, minute: null, second: null };

    @Input() targetMeasureList: any = [];
    @Input() targetDimensionList: any = [];
    @Input() formulaMeasure: boolean;

    constructor(public measureService: MDMService, public toaster: ToasterComponent, vcr: ViewContainerRef,
        public _sanitizer: DomSanitizer, public ngbDateConv: NgbDateConverter, public ngbTimeConv: NgbTimeConverter) {
        this.toaster.setViewRef(vcr);
        this.dimFilterSettings = {
            singleSelection: false,
            text: "Select Values",
            // enableSearchFilter: true,
            labelKey: 'name',
            primaryKey: 'name',
            enableCheckAll: false,
            noDataLabel: 'Empty dimension value',
            // classes: "form-control"
        };
    }

    ngOnChanges() {
        // if (this.isEdit) {
        // this.getMeasureById();
        // this.loadUom();
        // }
        this.initializer();
    }

    initializer() {
        let self = this;
        this.loadUom().then(res => {
            if (self.parent == 'wizard') {
                if (self.isEdit) {
                    this.getDataFromMeasure();
                }
                self.targetMeasureList.forEach((ele) => {
                    self.trgMeasures.push(ele.measureData);
                });
                self.setDimensionDataMap()
                self.dimensionFilterList = self.measureData.dimensionFilterList ? self.measureData.dimensionFilterList : [];
                // self.setMentionConfig();
                self.copyDim = self.trgDimension;
                self.loadTargets();
                // self.sortTargets();
            } else {
                this.getMeasureById();
                this.getDimensionByMesId();
            }
            this.getTimeDimension();
        });
    }

    getDimensionByMesId() {
        let self = this;
        let url = BiUrls.DIMENSION + BiUrls.DIMENSION_BY_MEASURES;
        if (self.measureData.id) {
            self.measureService.getDimensionByMeasureId(url, self.measureData.id).then((res) => {
                if (res == undefined || (res.error != undefined && res.status != true)) {
                    self.toaster.showError('This Measure is not linked to any cube.');
                } else if (res.data && res.data.length) {
                    self.targetDimensionList = res.data;
                    self.setDimensionDataMap();
                }
            });
        }
    }

    setDimensionDataMap() {
        let self = this;
        self.targetDimensionList.forEach(dim => {
            let levelMap = new Map;
            // self.trgDimension.push(dim.dimensionData);
            let dimData = self.parent == 'wizard' ? dim.dimensionData : dim;
            let dimId = self.parent == 'wizard' ? +dim.dimensionId : +dim.refId;
            if (!dimData.dimTime) {
                dimData.allDimHierarchyLevel.forEach(level => {
                    if (level.field) {
                        self.trgDimension.push(level);
                        self.levelMap.set(+level.id, level);
                        self.dimLevelIdMap.set(level.displayName ? level.displayName : level.field.fieldName, [dimId, +level.id]);
                    }
                });
            }
        });
    }

    getDataFromMeasure() {
        let self = this;
        self.processDataVersion('edit');
        self.indicators = self.measureData.measureStatusIndicator;
        self.measureTargets = self.measureData.measureTarget;
        if (self.measureTargets != undefined && self.measureTargets.length > 0) {
            self.trgType = self.measureTargets[0].type;
        } else {
            self.trgType = 'Static';
        }
        for (let i = 0; i < self.indicators.length; i++) {
            self.indicators[i].code = '#' + this.indicators[i].code;
        }
        self.measureTargets = _.sortBy(self.measureTargets, function (s) {
            return s.targetOrder;
        });
    }

    getMeasureById() {
        let self = this;
        self.loader = true;
        if (self.measureData.id) {
            self.measureService.getDataById('../' + BiUrls.MEASURE, self.measureData.id).then(res => {
                self.isEdit = true;
                self.measureData = res.data;
                // self.dimensionFilterList = self.measureData.dimensionFilterList;
                self.selectedDimLvlId = res.data.dimLevels ? res.data.dimLevels : [];
                self.getDataFromMeasure();
                self.loadMeasureTargets(self.measureData.id);
                self.loadTargets();

            });
        }
        self.loader = false;
    }

    loadMeasureTargets(measureId) {
        let self = this;
        let url = BiUrls.MEASURE + BiUrls.MEASURES_BY_CUBEMEASURES;
        self.measureService.getDataById(url, measureId).then((res) => {
            if (res == undefined || (res.error != undefined && res.status != true)) {
                self.toaster.showError('This Measure is not linked to any cube.');
            } else {
                res.data = res.data.filter(x => x.id != +measureId);
                self.trgMeasures = res.data;
                self.sortTargets();
            }
        });
    }

    sortTargets() {
        this.trgMeasures.sort((obj1, obj2) => {
            let str1 = obj1['measureDisplayName'].toLowerCase();
            let str2 = obj2['measureDisplayName'].toLowerCase();
            if (str1 < str2) {
                return -1;
            } else if (str1 > str2) {
                return 1;
            } else {
                return 0;
            }
        });
    }

    loadTargets() {
        return new Promise((resolve) => {
            let self = this;
            this.measureService.getAll(BiUrls.TARGET).then((res) => {
                self.corTrgList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            });
        });
    }

    public onDateChange(event) {
        this.measureData.dataVersion = event.target.value;
        this.datePicker = false;
    }

    public removeSelectedDate(event) {
        this.datePicker = true;
    }

    public addIndicators() {
        let obj = { id: null, name: '', value: null, code: '#000000', measureId: null, deleted: 0 };
        if (this.isEdit) {
            obj.measureId = this.measureData.id;
        }
        this.indicators.push((obj));
    }

    public onSelectColor(event, str) {
        if (str == 'indicator') {
            for (let indicator of this.indicators) {
                if (event.target.id == this.indicators.indexOf(indicator)) {
                    indicator.code = event.target.value;
                }
            }
        } else if (str == 'target') {
            for (let target of this.measureTargets) {
                if (event.target.id == this.measureTargets.indexOf(target)) {
                    target.color = event.target.value;
                }
            }
        }
        return;
    }

    public onIndicatorDelete(event, indicator) {
        let r = confirm('Are you sure you want to remove the indicator ' + indicator.name + ' ?');
        if (r == true) {
            this.toaster.showSuccess('Indicator removed successfully');
            this.indicators.splice(event.target.id, 1);
        }
    }

    public addTarget() {
        let self = this;
        let obj = {
            id: null, measureId: null, name: '', trgMeasureId: null, type: self.trgType, value: null,
            corTargetId: null, targetOrder: null, color: null, deleted: 0
        };
        if (self.isEdit) {
            obj.measureId = self.measureData.id;
        }
        self.measureTargets.push(obj);
    }

    public onSelectTrgType(event) {
        let self = this;
        let oldValue = self.trgType;
        self.trgType = event.target.value;
        if (self.measureTargets.length > 0) {
            let decision = confirm('Are you sure you want to change Target-Type ?' +
                '( All Previous Target data will be lost )');
            if (decision == true) {
                self.measureTargets = [];
            } else {
                self.trgType = oldValue;
            }
        }
    }

    public onSelectTarget(event, trgInd) {
        this.measureTargets[trgInd]['corTargetId'] = event.target.value != "None" ? Number(event.target.value) : null;
    }

    public onSelectTrgMeasure(event, trgInd) {
        this.measureTargets[trgInd]['trgMeasureId'] = event.target.value != "None" ? Number(event.target.value) : null;
    }

    public onTargetDelete(event, measureTarget) {
        let r = confirm('Are you sure you want to remove this target ' +
            measureTarget.name + ' ?');
        if (r == true) {
            this.toaster.showSuccess('Linking of Target removed successfully');
            let index = this.measureTargets.indexOf(measureTarget);
            this.measureTargets.splice(index, 1);
        }
    }

    public save() {
        let self = this;
        self.processDataVersion('save');
        let validate: any = this.validator();
        this.saveButtonDisable = true;

        if (validate != '') {
            this.toaster.showError(validate);
            this.saveButtonDisable = false;
        } else {
            if (this.measureData.rollup) {
                this.measureData.dimLevels = this.selectedDimLvlId;
            } else {
                this.measureData.dimLevels = [];
                this.measureData.aggType = null;
            }
            this.saveButtonDisable = false;
            if (this.parent == 'wizard') {
                this.triggerSave.emit(this.measureData);
            } else {
                this.saveCall();
            }
        }
    }

    public validator() {
        if (this.measureData.name == undefined || this.measureData.name.trim() == '') {
            return 'Please enter the name for measure';
        }
        if (this.measureData.measureDisplayName == undefined
            || this.measureData.measureDisplayName.trim() == '') {
            return 'Please enter the display name for measure';
        }
        if (this.formulaMeasure && (this.measureData.formulaExpression == undefined
            || this.measureData.formulaExpression.trim() == '')) {
            return 'Please enter the Formula Expression for measure';
        }
        if (this.measureData.rollup && (this.measureData.aggType == undefined
            || this.measureData.aggType.trim() == '')) {
            return 'Please select the aggregation type for Roll Up';
        }
        if (this.measureData.rollup && !this.selectedDimLvlId.length) {
            return 'Please select the dimension for Roll Up';
        }
        let msg = this.dateValidator();
        if (msg != '') {
            return msg;
        }
        msg = this.indicatorValidator();
        if (msg != '') {
            return msg;
        }
        msg = this.targetValidator();
        if (msg != '') {
            return msg;
        }
        msg = this.dimFilterValidator()
        if (msg != '') {
            return msg;
        }
        this.setMeasure();
        return '';
    }

    public dateValidator() {
        let self = this;
        if (this.startDataVersion && this.dataVersionDate) {
            let startDateMillisecond = (new Date(self.startDataVersion.year + "-" +
                self.startDataVersion.month + "-" + self.startDataVersion.day + " " +
                (self.startDataVersionTime ? self.startDataVersionTime.hour : 0) + ":" + (self.startDataVersionTime ? self.startDataVersionTime.minute : 0)).getTime());
            let endDateMillisecond = (new Date(self.dataVersionDate.year + "-" +
                self.dataVersionDate.month + "-" + self.dataVersionDate.day + " " +
                (self.dataVersionTime ? self.dataVersionTime.hour : 0 )+ ":" + (self.dataVersionTime ? self.dataVersionTime.minute : 0)).getTime());
            if (startDateMillisecond > endDateMillisecond) {
                return 'Start-Date cannot be greater than End-Date !';
            }
        }
        return '';
    }

    public indicatorValidator() {
        for (let indicator of this.indicators) {
            if (indicator.name == undefined || indicator.name.trim() == '') {
                return 'Please enter details for the indicators';
            }
            if (indicator.value == null) {
                return 'Please enter details for the indicators';
            }
            if (!(/^#[A-Fa-f0-9]{6}$/i.test(indicator.code))) {
                return 'Please enter valid hexadecimal value for indicator color';
            }
        }
        return '';
    }

    public targetValidator() {
        this.measureTargets.forEach((mt, i) => {
            if (mt.name == '') {
                return 'Target Name is required';
            }
            if (this.trgType == 'Static') {
                if (mt.value == null) {
                    return 'Please Enter Target Value';
                }
                mt.value = mt.value.toString();
            }
            if (this.trgType == 'Dynamic') {
                if (mt.trgMeasureId == null) {
                    return 'Please Select the target-measure';
                }
            }
            if (this.trgType == 'Core') {
                if (mt.corTargetId == null) {
                    return 'Please Select the Cor-Target';
                }
            }
            this.measureTargets[i].targetOrder = i;
        });

        if (this.trgType == 'Dynamic') {
            let trgMeaIdList = this.measureTargets.map(mt => mt.trgMeasureId);
            if (this.hasDuplicates(trgMeaIdList)) {
                return 'Attached target-measures should not be repeated !!!';
            }
        }

        if (this.trgType == 'Core') {
            let trgIdList = this.measureTargets.map(mt => mt.corTargetId);
            if (this.hasDuplicates(trgIdList)) {
                return 'Attached targets should not be repeated !!!';
            }
        }
        return '';
    }

    public setMeasure() {
        for (let indicator of this.indicators) {
            indicator.code = indicator.code.slice(1);
        }
        this.measureData.measureStatusIndicator = this.indicators;
        this.measureData.measureTarget = this.measureTargets;
    }

    hasDuplicates(array) {
        return (new Set(array)).size !== array.length;
    }

    onBack() {
        this.triggerBack.emit();
    }

    public saveCall() {
        let self = this;
        if (self.isEdit) {
            self.measureService.update(BiUrls.MEASURE, self.measureData).then(res => {
                res['type'] = 'edit';
                self.triggerSave.emit(res);
            });
        } else {
            self.measureService.save(BiUrls.MEASURE, self.measureData).then(res => {
                res['type'] = 'new';
                self.triggerSave.emit(res);
            });
        }
        self.setPageFieldSAfterLoading();
    }

    public setPageFieldSAfterLoading() {
        let self = this;
        self.saveButtonDisable = false;
        self.indicators = [];
        self.target = false;
    }

    public loadUom() {
        return new Promise((resolve) => {
            let self = this;
            this.measureService.onStartUp(BiUrls.UOM).then((res) => {
                self.uomList = res != undefined && res.data != undefined ? res.data : [];
            });
            resolve('completed');
        });
    }

    public onSelectUom(event) {
        if ((typeof event.target.value != 'string') && (event.target.value != 'none')) {
            this.measureData.uomId = null;
        } else {
            let id: any = Number.parseInt(event.target.value);
            if (typeof id == 'number') {
                this.measureData.uomId = id
                for (let x of this.uomList) {
                    if (id == x.id) {
                        this.measureData['uomId'] = x.id;
                    }
                }
            }
        }
    }

    public processDataVersion(action) {
        let self = this;
        if (action == 'save') {
            // let date = Date.parse(self.ngbDateConv.toModel(self.dataVersionDate));
            self.measureData.dataVersionType = self.dataVersionType;
            self.measureData["startDataVersion"] = self.startDataVersion && self.startDataVersion.day ? Date.parse(self.ngbDateConv.toModel(self.startDataVersion)) : null;
            self.measureData["startDataVersionTime"] = self.startDataVersionTime ? self.ngbTimeConv.toModel(self.startDataVersionTime) : null;

            if (self.measureData.dataVersionType == 'Static') {
                self.measureData["dataVersion"] = self.dataVersionDate && self.dataVersionDate.day ? Date.parse(self.ngbDateConv.toModel(self.dataVersionDate)) : null;
                self.measureData["dataVersionTime"] = self.dataVersionTime ? self.ngbTimeConv.toModel(self.dataVersionTime) : null;
            } else {
                self.measureData["dataVersion"] = null;
                delete self.measureData["dataVersionTime"];
            }
        } else {
            if (self.measureData.dataVersionType != undefined && self.measureData.dataVersionType == 'Static' && self.measureData.dataVersion) {
                self.dataVersionType = 'Static';
                let dateTime = new Date(self.measureData.dataVersion);
                let dvDate = dateTime.getUTCDate() + '-' + (dateTime.getUTCMonth() + 1) + '-' + dateTime.getUTCFullYear();
                self.dataVersionDate = self.ngbDateConv.fromModel(dvDate);
                let endDvTime: any = self.ngbTimeConv.fromModel(dateTime.getUTCHours() + ":" + dateTime.getUTCMinutes() + ":" + dateTime.getUTCSeconds());
                if (!!endDvTime.hour || !!endDvTime.minute) {
                    self.dataVersionTime = endDvTime;
                } else if(self.measureData["dataVersionTime"]){
                    self.dataVersionTime = self.ngbTimeConv.fromModel(self.measureData["dataVersionTime"]);
                }
            } else {
                self.dataVersionType = 'Dynamic';
            }
            if (self.measureData.startDataVersion) {
                let startDate = new Date(self.measureData.startDataVersion);
                self.startDataVersion = self.ngbDateConv.fromModel(startDate.getUTCDate() + '-' + (startDate.getUTCMonth() + 1) + '-' + startDate.getUTCFullYear());
                let startDvTime: any = self.ngbTimeConv.fromModel(startDate.getUTCHours() + ":" + startDate.getUTCMinutes() + ":" + startDate.getUTCSeconds());
                if (!!startDvTime.hour || !!startDvTime.minute) {
                    self.startDataVersionTime = startDvTime;
                } else if(self.measureData["startDataVersionTime"]) {
                    self.startDataVersionTime = self.ngbTimeConv.fromModel(self.measureData["startDataVersionTime"]);
                } else {
                    self.startDataVersionTime = self.ngbTimeConv.fromModel(0 + ":" + 0 + ":" + 0);
                }
            }
        }
    }

    changeDataVersionType(event){
        if(event.target.value == 'Dynamic'){
            this.dataVersionDate = null;
        }
    }

    public onMentionSelect(mention) {
        return '`' + mention.name + '`';
    }

    addDimensionFilter() {
        let filterDim = this.filterDim;
        if (filterDim && this.filterType && this.filterValue && this.filterValue.length > 0) {
            try {
                let value = [];
                this.filterValue.forEach(ele => {
                    value.push(ele.name);
                });
                let expression = {
                    'dimensionId': this.dimLevelIdMap.get(filterDim)[0],
                    'dimensionLevelId': this.dimLevelIdMap.get(filterDim)[1], "values": value,
                    "deleted": false, "filterType": this.filterType, "measureId": this.measureData.id
                };
                this.dimensionFilterList.push(expression);
                this.measureData.dimensionFilterList = this.dimensionFilterList;
            } catch (e) {
                console.log(e);
            }
        }
    }

    getDimensionValue(dimData, dim?) {
        let self = this;
        self.spinner = false;
        self.measureService.dimensionData(dimData).then(res => {
            if (res && res.response && res.response.data && res.response.data.length) {
                self.trgValues = res.response.data;
                if (dim) {
                    let value = [];
                    this.trgValues.forEach(ele => {
                        dim.values.forEach(val => {
                            if (ele.name == val) {
                                value.push(ele);
                            }
                        });
                    });
                    this.filterValue = value;
                }
                // self.setMentionConfig('`');
            } else {
                self.trgValues = [];
            }
            self.spinner = true;
        });
    }

    addfilterDim(event) {
        if (event && event != '') {
            let dimName = event
            // .field.fieldName;
            this.filterDim = dimName;
            let dimData = {
                "dimensionYAxis": [{
                    "dimension": { "id": this.dimLevelIdMap.get(dimName)[0] },
                    "level": { "id": this.dimLevelIdMap.get(dimName)[1] }
                }]
            };
            this.getDimensionValue(dimData);
        } else {
            this.filterDim = null;
        }
        this.getExistingFilter();
    }

    // public dimListFormatter = (data: any): SafeHtml => {
    //     let html = `<span>${data.field.fieldName}</span>`;
    //     return this._sanitizer.bypassSecurityTrustHtml(html);
    // }

    // public dimValueFormatter = (data: any): string => {
    //     let html = `${data.field.fieldName}`;
    //     return html;
    // }

    addfilterValue(event) {
        if (event.name != '') {
            // event = event.name;
            let ind = -1;
            if (this.filterDim && this.dimensionFilterList) {
                let dimensionId = this.dimLevelIdMap.get(this.filterDim)[0];
                let dimLvlId = this.dimLevelIdMap.get(this.filterDim)[1];
                this.dimensionFilterList.forEach((dim, i) => {
                    if (dim.dimensionId == dimensionId && dim.dimensionLevelId == dimLvlId && dim.filterType == this.filterType) {
                        ind = i;
                    }
                });
            }
            if (ind != -1) {
                // this.filterValue = [];
                !this.dimensionFilterList[ind].values.includes(event.name) ? this.dimensionFilterList[ind].values.push(event.name) : null;
            } else {
                !this.filterValue.includes(event) ? this.filterValue.push(event) : null;
                this.addDimensionFilter();
            }
        }
    }

    OnItemDeSelect(event) {
        if (this.filterDim) {
            let ind = -1;
            let dimensionId = this.dimLevelIdMap.get(this.filterDim)[0];
            let dimLvlId = this.dimLevelIdMap.get(this.filterDim)[1];
            this.dimensionFilterList.forEach((dim, i) => {
                if (dim.dimensionId == dimensionId && +dim.dimensionLevelId == +dimLvlId && dim.filterType == this.filterType) {
                    ind = i;
                }
            });
            if (ind != -1) {
                this.dimensionFilterList[ind].values.splice(this.dimensionFilterList[ind].values.indexOf(event.name), 1);
            }
        }
    }

    removeDimFilter(event, dim) {
        event.stopPropagation();
        if (dim.hasOwnProperty('id')) {
            this.dimensionFilterList[this.dimensionFilterList.indexOf(dim)].deleted = true;
        }
        else {
            this.dimensionFilterList.splice(this.dimensionFilterList.indexOf(dim), 1);
        }
        this.filterDim = null;
        this.filterType = null;
        this.filterValue = [];
    }

    selectDimFilter(dim) {
        let val = this.levelMap.get(+dim.dimensionLevelId).displayName ? this.levelMap.get(+dim.dimensionLevelId).displayName : this.levelMap.get(+dim.dimensionLevelId).field.fieldName;
        this.filterDim = val;
        this.filterType = dim.filterType;
        let dimData = {
            "dimensionYAxis": [{
                "dimension": { "id": this.dimLevelIdMap.get(this.filterDim)[0] },
                "level": { "id": this.dimLevelIdMap.get(this.filterDim)[1] }
            }]
        };
        this.getDimensionValue(dimData, dim);
    }

    reorder() {
        for (let k = 0; k < this.measureTargets.length; k++) {
            this.measureTargets[k].targetOrder = k;
        }
    }

    dimFilterValidator() {
        let msg = ''
        if (this.dimensionFilterList && this.dimensionFilterList.length) {
            for (let filter of this.dimensionFilterList) {
                if (filter.values && !filter.values.length) {
                    msg = 'Please select value for dimension filter!';
                    this.selectDimFilter(filter);
                    break;
                }
            }
        }
        return msg;
    }

    getExistingFilter() {
        let self = this;
        this.filterValue = [];
        if (self.filterDim && self.filterType) {
            try {
                for (let filter of self.dimensionFilterList) {
                    let val = self.levelMap.get(+filter.dimensionLevelId).displayName ? self.levelMap.get(+filter.dimensionLevelId).displayName : self.levelMap.get(+filter.dimensionLevelId).field.fieldName;
                    if (self.filterDim == val && self.filterType.toLowerCase() == filter.filterType.toLowerCase()) {
                        self.selectDimFilter(filter);
                        break;
                    }
                }
            } catch (e) { }
        }
    }

    selectAggDimLevels(event) {
        let id = event.target.value;
        if (id && id != '' && !this.selectedDimLvlId.includes(id)) {
            this.selectedDimLvlId.push(id);
        }
    }

    removeAggDimLevels(dimId) {
        let ind = this.selectedDimLvlId.indexOf(dimId);
        if (ind != -1) {
            this.selectedDimLvlId.splice(ind, 1);
        }
    }

    getDimName(dimId) {
        let dimData = this.levelMap.get(+dimId);
        if (dimData && dimData.field) {
            return dimData.field.displayName;
        }
    }

    getTimeDimension() {
        let id = this.measureData.id ? this.measureData.id : this.trgMeasures[0] ? this.trgMeasures[0].id : null;
        this.measureService.getTimeDimension([id]).then(res => {
            let cubeId: any = new Map();
            if (res && res.data) {
                res.data.forEach(re => {
                    if (!cubeId.has(re.cubeId)) {
                        cubeId.set(re.cubeId, [re]);
                    } else {
                        cubeId.get(re.cubeId).push(re);
                    }
                });
                this.timeDimensionMap = cubeId;
                this.timeDimensionKey = Array.from(cubeId.keys());
            }
        });
    }

    setTimeFilter(dimId, typeCheck, ) {
        let type = typeCheck ? 'rangeStartDate' : 'rangeEndDate';
        if (dimId) {
            this.measureData[type] = +dimId;
        } else {
            this.measureData[type] = null;
        }
    }

    setStartDvTime(time) {
        this.startDataVersionTime = time;
    }

    setDvTime(time) {
        this.dataVersionTime = time;
    }

    clearStartDate() {
        this.startDataVersion = { day: null, month: null, year: null };
        this.startDataVersionTime = { hour: null, minute: null, second: null };
    }

}


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/measureEdit.component.ts